export const AUTH_CONFIG = {
  domain: 'automech.auth0.com',
  clientId: 'EXbJGHm6sQqbNFriRHjuGtD47IpG7X7v',
  callbackUrl:
    process.env.REACT_APP_AUTH_CALLBACK_URL ||
    'https://localhost:3002/authcallback'
}



// WEBPACK FOOTER //
// ./src/auth/auth0-variables.js